import Avatar from "../../../../../components/UICustom/Avatar";
import common from "../../../../../utils/common";
import { cn } from "../../../../../utils/utils";
import { highlightText } from "../../../../../utils/highlightText";

const SearchResultItem = ({
  result,
  searchQuery,
  activeTab,
  onClick,
  subqueries,
  isFocused,
}) => {
  return (
    <div
      className={cn(
        "cursor-pointer py-3 px-4",
        isFocused ? "bg-secondary" : "hover:bg-secondary",
      )}
      data-focused={isFocused || undefined}
      onClick={() => onClick(result)}
    >
      <div className="flex items-start gap-3">
        <Avatar user={result} size="md" />

        <div className="flex-1 min-w-0">
          <div className="flex justify-between items-start">
            <h3 className={cn("font-medium truncate", "text-gray-700")}>
              {highlightText(result.name, subqueries)}
            </h3>
            {result.messages && result.messages.length > 0 && (
              <span className="text-xs text-gray-500 ml-2 shrink-0">
                {result.messages &&
                  result.messages.length > 0 &&
                  common.getPreviewTimeContact(
                    result.messages[result.messages.length - 1].dateAction
                  )}
              </span>
            )}
          </div>
          <p className="text-sm text-gray-500 truncate mt-0.5">
            {result.messages &&
              result.messages.length > 0 &&
              (() => {
                const preview =
                  activeTab === "people"
                    ? result.messages[result.messages.length - 1].content
                    : (result.messages
                        .filter((msg) =>
                          common
                            .normalizeText(msg.content)
                            .includes(common.normalizeText(searchQuery))
                        )
                        .reverse()[0]?.content ??
                        result.messages[result.messages.length - 1]?.content);
                return activeTab === "messages"
                  ? highlightText(preview, subqueries)
                  : preview;
              })()}
          </p>
        </div>
      </div>
    </div>
  );
};

export default SearchResultItem;
